import Executive from '../../framework/rmi-util'
import {
	startCancelOrdersJob,
	getJobStatus,
	getJobsByContainer,
	getCancelOrdersJobs,
	startExportProductJob,
	retryExportProductJob,
	getExportProductJobs,
	getExportProductJobsPaginated,
	startExportServiceProviderJob,
	retryExportServiceProviderJob,
	getExportServiceProviderJobs,
	getExportServiceProviderJobsPaginated,
} from './BackgroundJobTechnical'
import { register } from '../../framework/rmi-server-util'
import { context } from '../../framework/context-util'
import {
	StartCancelOrdersJobRequest,
	StartJobResponse,
	JobStatusResponse,
	StartExportProductJobRequest,
	ExportTarget,
	BackgroundJobDto,
	StartExportServiceProviderJobRequest,
	PaginatedJobsResponse,
} from './types'

export default class BackgroundJobExecutive extends Executive {

	initServer() {
	}

	// @CheckApiKey()
	async startCancelOrdersJob(request: StartCancelOrdersJobRequest): Promise<StartJobResponse> {
		const createdBy = context.userEmail || 'api-user'
		return await startCancelOrdersJob(request, createdBy)
	}

	async getJobStatus(jobId: string): Promise<JobStatusResponse> {
		return await getJobStatus(jobId)
	}

	async getJobsByContainer(containerKey: string): Promise<BackgroundJobDto[]> {
		return await getJobsByContainer(containerKey)
	}

	async getCancelOrdersJobs(productId: string, date: string, timeSlot: string): Promise<BackgroundJobDto[]> {
		return await getCancelOrdersJobs(productId, date, timeSlot)
	}

	// ============================================
	// Export Product Job Methods
	// ============================================

	async startExportProductJob(request: StartExportProductJobRequest): Promise<StartJobResponse> {
		const createdBy = request.createdBy || context.userEmail || 'api-user'
		return await startExportProductJob(request, createdBy)
	}

	async retryExportProductJob(jobId: string, failedTarget: ExportTarget): Promise<StartJobResponse> {
		const createdBy = context.userEmail || 'api-user'
		return await retryExportProductJob(jobId, failedTarget, createdBy)
	}

	async getExportProductJobs(productId: string, clientId: string): Promise<BackgroundJobDto[]> {
		return await getExportProductJobs(productId, clientId)
	}

	async getExportProductJobsPaginated(
		productId: string,
		clientId: string,
		limit: number = 3,
		offset: number = 0
	): Promise<PaginatedJobsResponse> {
		return await getExportProductJobsPaginated(productId, clientId, limit, offset)
	}

	// ============================================
	// Export Service Provider Job Methods
	// ============================================

	async startExportServiceProviderJob(request: StartExportServiceProviderJobRequest): Promise<StartJobResponse> {
		const createdBy = request.createdBy || context.userEmail || 'api-user'
		return await startExportServiceProviderJob(request, createdBy)
	}

	async retryExportServiceProviderJob(jobId: string): Promise<StartJobResponse> {
		const createdBy = context.userEmail || 'api-user'
		return await retryExportServiceProviderJob(jobId, createdBy)
	}

	async getExportServiceProviderJobs(serviceProviderId: string, clientId: string): Promise<BackgroundJobDto[]> {
		return await getExportServiceProviderJobs(serviceProviderId, clientId)
	}

	async getExportServiceProviderJobsPaginated(
		serviceProviderId: string,
		clientId: string,
		limit: number = 3,
		offset: number = 0
	): Promise<PaginatedJobsResponse> {
		return await getExportServiceProviderJobsPaginated(serviceProviderId, clientId, limit, offset)
	}
}

register(BackgroundJobExecutive)
